import { useEffect, useState } from 'react'
import type { UnitMapping } from '../lib/types'

interface Props {
  label: string
  mapping: UnitMapping | undefined
  onChange: (mapping: UnitMapping | null) => void
}

/**
 * For booking systems that cannot list their accommodations: both ids are free text, so they can be
 * typed straight from the PMS. Leave both empty to unlink.
 */
export default function ManualMappingCell({ label, mapping, onChange }: Props) {
  const storedUnit = mapping?.externalUnitId ?? null
  const storedType = mapping?.externalTypeId ?? null
  const [unitId, setUnitId] = useState(storedUnit ?? '')
  const [typeId, setTypeId] = useState(storedType ?? '')

  useEffect(() => setUnitId(storedUnit ?? ''), [storedUnit])
  useEffect(() => setTypeId(storedType ?? ''), [storedType])

  const commit = () => {
    const nextUnit = unitId.trim() === '' ? null : unitId.trim()
    const nextType = typeId.trim() === '' ? null : typeId.trim()
    if (nextUnit === storedUnit && nextType === storedType) return
    onChange(nextUnit === null && nextType === null ? null : { externalUnitId: nextUnit, externalTypeId: nextType })
  }

  return (
    <div style={{ display: 'flex', gap: '0.3rem' }}>
      <input
        type="text"
        value={unitId}
        placeholder="plaats-id"
        aria-label={`Externe plaats-id voor ${label}`}
        style={{ width: '4.75rem' }}
        onChange={(event) => setUnitId(event.target.value)}
        onBlur={commit}
      />
      <input
        type="text"
        value={typeId}
        placeholder="type-id"
        aria-label={`Extern type-id voor ${label}`}
        style={{ width: '4.75rem' }}
        onChange={(event) => setTypeId(event.target.value)}
        onBlur={commit}
      />
    </div>
  )
}
